import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import { WA_MESSAGES, openWhatsApp } from '../../../config/site';

const TEAM = [
  {
    id: 1,
    name: 'Kavita Thakur',
    avatar: '/assets/images/gen/avatar-kt.svg',
    role: 'Head of Player Experience',
    experience: '12+ years in customer service',
    specialties: ['Onboarding', 'WhatsApp desk', 'Escalations'],
    bio: 'Built the WhatsApp desk from a single phone into a 24×7 operation. If a reply takes more than two minutes, she wants to know why.',
    languages: 'English · Hindi · Marathi',
    online: true,
  },
  {
    id: 2,
    name: 'Manish Joshi',
    avatar: '/assets/images/gen/avatar-mj.svg',
    role: 'Senior Cashier Specialist',
    experience: '9 years in payments',
    specialties: ['UPI & wallets', 'Withdrawals', 'KYC'],
    bio: 'Owns the payout pipeline. Nudge him about a slow withdrawal and it usually clears before the chat ends.',
    languages: 'English · Hindi · Gujarati',
    online: true,
  },
  {
    id: 3,
    name: 'Arjun Rao',
    avatar: '/assets/images/gen/avatar-ar.svg',
    role: 'Game Strategy Advisor',
    experience: '11 years at live tables',
    specialties: ['Teen Patti', 'Cricket exchange', 'Bankroll'],
    bio: 'Writes the free strategy packs. Ask him about table selection before you ask about luck.',
    languages: 'English · Hindi · Telugu',
    online: true,
  },
  {
    id: 4,
    name: 'Sana Gill',
    avatar: '/assets/images/gen/avatar-sg.svg',
    role: 'VIP Relationship Manager',
    experience: '8 years in VIP services',
    specialties: ['VIP limits', 'Cashback', 'Private tables'],
    bio: 'Looks after high-stake players — custom limits, faster lanes and a direct line that never goes to a queue.',
    languages: 'English · Hindi · Punjabi',
    online: false,
  },
];

const ExpertTeam = () => (
  <section className="relative overflow-hidden py-24">
    <span className="aurora left-[-8%] top-[10%] h-96 w-96 bg-trust-blue/25" aria-hidden="true" />

    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-3xl text-center">
        <span className="badge-pill"><Icon name="Users" size={13} /> The people behind the number</span>
        <h2 className="mt-6 font-heading text-display font-bold text-white">
          You are messaging <span className="gold-text">actual humans</span>
        </h2>
        <p className="mt-4 text-body-lg text-white/60">
          Four specialists cover the Nitin Online Book desk around the clock. Here is who picks up when you write.
        </p>
      </div>

      <div className="perspective mt-14 grid gap-6 sm:grid-cols-2">
        {TEAM.map((m, i) => (
          <article key={m.id} className="card-3d animate-rise p-7" style={{ animationDelay: `${i * 80}ms` }}>
            <div className="flex items-start gap-4">
              <div className="relative shrink-0">
                <Image src={m.avatar} alt={m.name} className="h-16 w-16 rounded-full" />
                <span
                  className={`absolute -bottom-0.5 -right-0.5 h-4 w-4 rounded-full border-2 border-[#0B0B14] ${
                    m.online ? 'bg-wa-green' : 'bg-white/30'
                  }`}
                />
              </div>

              <div className="min-w-0 flex-1">
                <h3 className="font-heading text-lg font-bold text-white">{m.name}</h3>
                <p className="font-display text-xs uppercase tracking-[0.14em] text-royal-gold">{m.role}</p>
                <p className="mt-1 text-xs text-white/45">{m.experience} · {m.languages}</p>
              </div>
            </div>

            <p className="mt-4 text-sm leading-relaxed text-white/55">{m.bio}</p>

            <div className="mt-4 flex flex-wrap gap-1.5">
              {m.specialties.map((s) => (
                <span key={s} className="rounded-full bg-white/[0.06] px-2.5 py-1 text-[0.66rem] text-white/55">
                  {s}
                </span>
              ))}
            </div>

            <button
              onClick={() => openWhatsApp(`Hi ${m.name.split(' ')[0]}! ${WA_MESSAGES.support}`)}
              className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-wa-green transition hover:gap-3"
            >
              <FaWhatsapp size={15} /> Message {m.name.split(' ')[0]}
            </button>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default ExpertTeam;
